import { jwtDecode } from "jwt-decode";

const initialState = {
  dashboardData: [],
  loading: false,
  toastMessage: "",
  toastOpen: false,
  error: null,
  mapData: {},
  markerData: {},
  loadError: null,
  isLoaded: null,
  deviceAddedSucess: false,
  deviceEditedSuccess: false,
  sendLicenceSuccess: false,
  editError: null,
  customerData: [],
  userListDataLoading: false,
  userListDataError: null,
  userListData: [],
};

const BuildingManagementReducer = (state = initialState, action) => {
  const token = JSON.parse(localStorage.getItem("token"));
  let decodedToken = '';
  if(token) {
    decodedToken = jwtDecode(token);
  }
  const userGuid = decodedToken.userGuid;
  switch (action.type) {
    case "BUILDING_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "BUILDING_DATA_SUCCESS":
      return {
        ...state,
        dashboardData: action.payload,
        loading: false,
        error: null,
      };
    case "BUILDING_DATA_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        dashboardData: [],
      };

    case "DELETE_BUILDING_SUCCESS":
      return {
        ...state,
        // message: action.payload,
        error: null,
      };

    case "DELETE_BUILDING_FAIL":
      return {
        ...state,
        // message: action.payload,
        error: action.payload,
      };
    case "ADD_BUILDING_SUCCESS":
      return {
        ...state,
        deviceAddedSucess: true,
      };
    case "ADD_BUILDING_FAIL":
      return {
        ...state,
        error: action.payload,
      };
    case "ADD_BUILDING_MODAL_CLEAR":
      return {
        ...state,
        deviceAddedSucess: false,
      };
    case "SET_TOAST_MESSAGE":
      return {
        ...state,
        toastMessage: action.payload,
      };
    case "SET_TOAST_OPEN":
      return {
        ...state,
        toastOpen: action.payload,
      };
    case "MAP_DATA":
      return {
        ...state,
        mapData: action.payload,
      };
    case "MAP_MARKER_DATA":
      return {
        ...state,
        markerData: action.payload,
      };
    case "RESET_MARKER_DATA":
      return {
        ...state,
        mapData: {},
        markerData: {},
      };
    case "ISLOADED_LOADERROR":
      return {
        ...state,
        loadError: action.payload.loadError,
        isLoaded: action.payload.isLoaded,
      };
    case "EDIT_BUILDING_REQUEST":
      return {
        ...state,
        loading: true,
        deviceEditedSuccess: false,
        editError: null,
      };
    case "EDIT_BUILDING_SUCCESS":
      return {
        ...state,
        loading: false,
        deviceEditedSuccess: true,
      };
      case "EDIT_ERROR_CLEAR":
      return {
        ...state,
        editError: null,
      };
    case "SEND_LICENCE_SUCCESS":
      return {
        ...state,
        sendLicenceSuccess: true,
      };
    case "CLEAR_LICENCE_SUCCESS":
      return {
        ...state,
        sendLicenceSuccess: false,
      };
    case "EDIT_BUILDING_FAILURE":
      return {
        ...state,
        loading: false,
        deviceEditedSuccess: false,
        editError: action.payload,
      };
    case "EDIT_BUILDING_MODAL_CLEAR":
      return {
        ...state,
        deviceEditedSuccess: false,
      };
    case "CUSTOMER_DATA_SUCCESS":
      return {
        ...state,
        customerData: action.payload,
        loading: false,
        error: null,
      };
    case "FETCH_USERS_FROM_CUSTOMER_LOADING":
      return {
        ...state,
        userListDataLoading: true,
        userListData: [],
        userListDataError: null,
      };
    case "FETCH_USERS_FROM_CUSTOMER_SUCCESS":
      return {
        ...state,
        userListDataLoading: false,
        userListData: action.payload.customerUsers.filter((user) => user.userGuid !== userGuid),
        userListDataError: null,
      };
    case "FETCH_USERS_FROM_CUSTOMER_ERROR":
      return {
        ...state,
        userListDataLoading: false,
        userListData: [],
        userListDataError: action.payload,
      };
    case "FETCH_BUILDING_PERSONEL_FROM_CUSTOMER_LOADING":
      return {
        ...state,
        buildingPersonelLoading: true,
        buildingPersonelData: [],
        buildingPersonelError: null,
      };
    case "FETCH_BUILDING_PERSONEL_FROM_CUSTOMER_SUCCESS":
      return {
        ...state,
        buildingPersonelLoading: false,
        buildingPersonelData: action.payload.buildingPersonnel.filter((buildindPersonalId) => buildindPersonalId !== userGuid),
        buildingPersonelError: null,
      };
    case "FETCH_BUILDING_PERSONEL_FROM_CUSTOMER_ERROR":
      return {
        ...state,
        buildingPersonelLoading: false,
        buildingPersonelData: [],
        buildingPersonelError: action.payload,
      };
    default:
      return state;
  }
};

export default BuildingManagementReducer;
